import { render, staticRenderFns } from "./PassVaccineSelectDocument.vue?vue&type=template&id=34f2bfbb&scoped=true&"
import script from "./PassVaccineSelectDocument.vue?vue&type=script&lang=ts&"
export * from "./PassVaccineSelectDocument.vue?vue&type=script&lang=ts&"
import style0 from "./PassVaccineSelectDocument.vue?vue&type=style&index=0&id=34f2bfbb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f2bfbb",
  null
  
)

export default component.exports